// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"SelfiesTip_style_b-icon-warning__layk8","wrapper":"SelfiesTip_style_wrapper__L5PxZ","rotate":"SelfiesTip_style_rotate__XAejy"};